/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import Icon from "../GlobalComponents/Icon";
import scheduleBg from "../Image/scheduleBg.jpg";

const Schedule = () => {

  return (
    <section css={styles} className="schedule" id="schedule">
      <h2>
        OPENING CLOSING <span>SCHEDULE</span>
      </h2>
      <Icon />
      <p>
      Hostel opens at 7:00 AM and it closes at 11:00 PM
        <br />
      
      </p>
      
    </section>
  );
};

const styles = css`
  width: 100%;
  padding: 25px 0;
  min-height: 10vh;
  text-align: center;
  background:  linear-gradient(
    rgba(0.0, 0.7, 0.8, 0.9), 
    rgba(0.0, 0.9, 0.1, 0.8)
        ),url('${scheduleBg}') no-repeat center/cover;
  h2 {
    color: #fff;
    font-weight: 900;
    font-size: 25px;
    letter-spacing: 1.3px;
    line-height: 1;
    span {
      color: #ed563b;
    }
  }
  p {
    color: white;
    font-weight:700;
    font-family: italic;
    font-size: 13px;
    line-height: 1.7;
    margin: 10px 0;
    word-spacing:3px;
  }
  .container{
      display: flex;
      flex-direction: column;
      align-items: center;
  }
  @media(max-width: 640px) {
    p{
      padding: 0 20px;
      br{
        display: none;
      }
    }
    .container{
      max-width: 82%;
    }
  }
`;

export default Schedule;
